import apiClient from './apiClient';
import { PageResponse } from '../types/facility.types';

export interface SecuritySettings {
  id?: string;
  settingProfile: string;
  require2fa: boolean;
  sessionTimeoutMins: number;
  passwordExpiryDays: number;
  tenantId?: string;
  clientId?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  facilityId?: string;
}

const BASE_PATH = 'v1/security';

class SecurityService {
  async getSecuritySettings(facilityId?: string): Promise<SecuritySettings | null> {
    const response = await apiClient.get<any>(BASE_PATH, {
      params: facilityId ? { facilityId } : {}
    });
    // Handle both direct object and paginated response
    if (response.data && response.data.content && Array.isArray(response.data.content)) {
      const content = response.data.content as SecuritySettings[];
      // Priority: 1. Exact facility match
      if (facilityId) {
        const facMatch = content.find(p => p.facilityId === facilityId);
        if (facMatch) return facMatch;
      }
      // 2. Default profile
      return content.find(p => p.settingProfile === 'Default') || content[0] || null;
    }
    return response.data;
  }

  async getAllSecuritySettings(page: number = 0, size: number = 20): Promise<PageResponse<SecuritySettings>> {
    const response = await apiClient.get<PageResponse<SecuritySettings>>(BASE_PATH, {
      params: { page, size, sort: 'createdAt' },
    });
    return response.data;
  }

  async updateSecuritySettings(data: Partial<SecuritySettings>): Promise<SecuritySettings> {
    const response = await apiClient.post(BASE_PATH, data);
    return response.data;
  }

  async updateSecurityProfile(id: string, data: Partial<SecuritySettings>): Promise<SecuritySettings> {
    const response = await apiClient.put(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async deleteSecurityProfile(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new SecurityService();
